import _ from 'lodash';

import { createIntercom } from './IntercomProvider';
import { getDisabledIntercom, isTestEnv } from '../devOpsHelper/DevOps';

export function deserialiseIntercomAppId(site_context) {
    return _.get(site_context, 'intercom_app_id');
}

export function deserialiseIntercomSettings(site_context) {
    return {
        custom_launcher_selector: '.ChatSupportButton',
        user_hash: _.get(site_context, 'user_intercom_hash')
    };
}

export function setupIntercom(appID) {
    if (isEnabledIntercom()) {
        window.Intercom = createIntercom();

        let s = document.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = `https://widget.intercom.io/widget/${appID}`;
        document.head.appendChild(s);
    } else if (!isEnabledIntercom() && !isTestEnv()) {
        console.log('Intercom widget is disabled');
    }
}

export function authenticateUser(appID, intercomSettings) {
    if (isEnabledIntercom()) {
        window.Intercom('boot', {
            app_id: appID,
            ...intercomSettings
        });
    }
}

export function reconnectIntercom(appID, intercomSettings) {
    if (isEnabledIntercom()) {
        window.Intercom('reattach_activator');
        window.Intercom('update', intercomSettings);
    }
}

export function updateIntercomOfPageChange() {
    if (isEnabledIntercom()) {
        window.Intercom('update');
    }
}

export function isEnabledIntercom() {
    return getDisabledIntercom() !== 'true';
}
